<template>
  <img :alt="alt" :class="styleClass" :src="url" :onerror="`this.src='${this.urlError}'`">
</template>
<script>
import http from 'axios'

export default {
  props: {
    alt: {
      type: String,
      default: ''
    },
    styleClass: {
      type: String,
      default: 'rounded-circle img-fluid"'
    },
    idProfissional: {
      type: String,
      required: true
    }
  },
  computed: {
    url () {
      return `${http.defaults.baseURL}/corpoClinicoImagem/${this.idProfissional}/logo`
    },
    urlError () {
      return require('@/img/avatar1.jpg')
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/shared/ImagemProfissional.vue